"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getBraintreeShippingOptionsGoogle = void 0;
const src_1 = require("../..");
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
function getBraintreeShippingOptionsGoogle() {
    const { iso_code: currencyCode } = (0, checkout_frontend_library_1.getCurrency)();
    const { available_shipping_lines: shippingLines, selected_shipping: selectedShipping } = (0, checkout_frontend_library_1.getShipping)();
    const defaultSelectedOptionId = selectedShipping === null || selectedShipping === void 0 ? void 0 : selectedShipping.id;
    if (!shippingLines || (Array.isArray(shippingLines) && shippingLines.length < 1)) {
        return;
    }
    const shippingOptions = shippingLines.map(p => ({
        id: p.id,
        label: `${(0, src_1.getValueByCurrency)(p.amount, currencyCode)}: ${p.description} `,
        description: ''
    }));
    return {
        shippingOptions,
        defaultSelectedOptionId
    };
}
exports.getBraintreeShippingOptionsGoogle = getBraintreeShippingOptionsGoogle;
